<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Ordem de corte',
        :voltarPara='voltarPara',
        icon='el-icon-plus',
        btnTexto='Inserir Documentos',
    )
    .view-container-base-header
        FiltroRastreabilidade(
            textoPlaceHolder='Busque por número da ordem de corte'
            @atualizar-filtro='atualizarFiltro'
        )
        
        .container-totalizadores
            h2 Total de ordens de corte cadastradas
            .totalizadores-lista
                div(v-for="item in this.dadosTotalizadores")
                    BaseCardTotalizadorRastreabilidade(
                        etapa='Ordens de corte'
                        :texto='item.descricaoTotalizador',
                        :numero='item.totalOrdemCorteCadastrado',
                        :data='item.ultimaAtualizacaoOrdemCorteCadastrado'
                        icone='corte'
                    )

        BotoesDeAcoesRastreabilidade(
            btnPlaceHolder='Inserir Ordem de Corte'
            @btnInserirClicado='openModalArquivo'
            @btnBaixarModeloClicado='baixarModeloArquivo'
        )
        
        TabelaOrdemDeCorte(
            v-loading='buscandoOrdemDeCorte',
            :dadosTabela='dadosTabela',
            :paginacao='paginacao',
            @atualizar-pagina='atualizarPagina',
            @atualizar-tabela='buscarOrdensCorte'
        )
        ModalInsercaoArquivoOrdemDeCorte(
            :show.sync='showModalArquivoOrdemDeCorte'
            @sucessoUpload='atualizarDadosTela'
            @closeModal='closeModalArquivo'
        )
</template>
    
<script>
import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
import TabelaOrdemDeCorte from '@/components/rastreabilidadeRaizen/ordemDeCorte/TabelaOrdemDeCorte';
import BotoesDeAcoesRastreabilidade from '@/components/rastreabilidadeRaizen/BotoesDeAcoesRastreabilidade';
import BaseCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/BaseCardTotalizadorRastreabilidade';

import RastreabilidadeOrdemDeCorteService from '@/services/RastreabilidadeOrdemDeCorteService';
import RastreabilidadeDocumentosService from '@/services/RastreabilidadeDocumentosService';

import ModalInsercaoArquivoOrdemDeCorte from '@/components/rastreabilidadeRaizen/ordemDeCorte/ModalInsercaoArquivoOrdemDeCorte';

export default {
    name: 'OrdemDeCorte',
    components: {
        BaseHeaderRastreabilidade,
        FiltroRastreabilidade,
        TabelaOrdemDeCorte,
        ModalInsercaoArquivoOrdemDeCorte,
        BotoesDeAcoesRastreabilidade,
        BaseCardTotalizadorRastreabilidade
    },
    data() {
        return {
            showModalArquivoOrdemDeCorte: false,
            nomeColumn: null,
            voltarPara: true,
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            },
            filtros: '',
            dadosTabela: [],

            dadosTotalizadores: [],

            buscandoOrdemDeCorte: true
        };
    },
    created() {
        this.buscarOrdensCorte(0);
        this.buscarTotalizadoresOrdemDeCorte();
    },
    methods: {
        btnHeaderClicado: function () {},

        async buscarOrdensCorte(pagina) {
            this.paginacao.pagina = pagina;
            await RastreabilidadeOrdemDeCorteService.buscar(
                this.filtros,
                this.paginacao
            ).then(({ data }) => {
                this.dadosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.paginacao.pagina += 1;
                this.buscandoOrdemDeCorte = false;
            });
        },

        async buscarTotalizadoresOrdemDeCorte() {
            const { data } =
                await RastreabilidadeOrdemDeCorteService.buscarTotalizadoresOrdemDeCorte();
            this.dadosTotalizadores = data;
        },

        async baixarModeloArquivo() {
                await RastreabilidadeDocumentosService.baixarModeloCsv('ORDEM_CORTE');
        },

        atualizarFiltro(dados) {
            this.filtros = dados;
            this.buscarOrdensCorte(0);
        },

        atualizarPagina(pagina) {
            this.buscarOrdensCorte(pagina);
        },

        openModalArquivo() {
            this.showModalArquivoOrdemDeCorte = true;
        },

        closeModalArquivo() {
            this.showModalArquivoOrdemDeCorte = false;
        },

        atualizarDadosTela() {
            this.buscarOrdensCorte(0);
            this.buscarTotalizadoresOrdemDeCorte();
        },

        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarOrdensCorte(0);
        }
    }
};
</script>
<style lang="scss" scoped>
#rastreabilidade-raizen  {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;

        span {
            padding-left: 3px;
            color: #1989fa;
            text-decoration-line: underline;
        }
    }

    .container-totalizadores {
        padding: 20px 35px 0px 20px;

        h2 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
            font-weight: bold;
        }
        .totalizadores-lista {
            width: 100%;
            height: 99px;
            margin: 0 auto;
            display: grid;
            gap: 12px;
            grid-template-columns: 33% 33% 33%;
        }

        .totalizadores-bloco {
            width: 32%;
        }
    }
}
</style>
